import {RouteEntry} from "../../shared/routes";
import {Quote} from "./Quote";

export const quoteRoutes: Array<RouteEntry> = [
    { path: '/quote/:id', component: Quote },
    { path: '/quote', component: Quote },
];
